import type { StyleRule } from '@archipro-design/aria';
import { paginationClassName } from '@archipro-design/aria';
import { pxToRem, paginationSlotClassNames } from '@archipro-design/aria';

export const PaginationWrapper: StyleRule = ({ theme }) => {
    return {
        paddingTop: pxToRem(33),
        paddingBottom: pxToRem(80),
        [`& .${paginationClassName}`]: {
            minWidth: pxToRem(377),
        },

        [theme.screen.laptop]: {
            paddingTop: pxToRem(23),
            height: pxToRem(300),
            [`& .${paginationClassName}`]: {
                width: 'auto',
                [`& .${paginationSlotClassNames.list}`]: {
                    marginBottom: pxToRem(24),
                },
            },
        },

        [`& .${paginationSlotClassNames.divider}`]: {
            display: 'none',
        },

        [`& .${paginationSlotClassNames.paginationMetaData}`]: {
            [`&> *:not(:last-child)`]: {
                margin: 0,
            },
        },
    };
};
